import React from "react";
import { DollarSign, Hourglass, Eye, RefreshCw } from "lucide-react";
import Dashboard4 from "./Dashboard4";

export default function Dashboard3() {
  const orderTotals = [
    { status: "Pending", today: "$0.00", week: "$0.00", month: "$0.00", year: "$2,468.80", all: "$2,468.80" },
    { status: "Processing", today: "$0.00", week: "$0.00", month: "$0.00", year: "$1,957.00", all: "$1,957.00" },
    { status: "Complete", today: "$0.00", week: "$0.00", month: "$0.00", year: "$43.50", all: "$43.50" },
    { status: "Cancelled", today: "$0.00", week: "$0.00", month: "$0.00", year: "$0.00", all: "$0.00" },
  ];

  const incompleteOrders = [
    {
      item: "Total unpaid orders (pending payment status)",
      total: "$2,468.80",
      count: 2,
    },
    {
      item: "Total not yet shipped orders",
      total: "$4,315.00",
      count: 2,
    },
    {
      item: "Total incomplete orders (pending order status)",
      total: "$2,468.80",
      count: 2,
    },
  ];

  return (
    <div className="p-4 sm:p-6 lg:p-10 bg-gray-50 min-h-screen">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Order Totals */}
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
          <div className="flex justify-between items-center border-b border-gray-200 p-4">
            <div className="flex items-center gap-2">
              <DollarSign className="text-gray-600" size={20} />
              <h2 className="text-lg font-semibold text-gray-700">Order totals</h2>
            </div>
            <button className="text-gray-500 hover:text-gray-700">
              <RefreshCw size={18} />
            </button>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-700 border-t border-gray-100">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-2 font-semibold">Order Status</th>
                  <th className="px-4 py-2 font-semibold">Today</th>
                  <th className="px-4 py-2 font-semibold">This Week</th>
                  <th className="px-4 py-2 font-semibold">This Month</th>
                  <th className="px-4 py-2 font-semibold">This Year</th>
                  <th className="px-4 py-2 font-semibold">All time</th>
                </tr>
              </thead>
              <tbody>
                {orderTotals.map((row, i) => (
                  <tr
                    key={i}
                    className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}
                  >
                    <td className="px-4 py-2 font-medium">{row.status}</td>
                    <td className="px-4 py-2">{row.today}</td>
                    <td className="px-4 py-2">{row.week}</td>
                    <td className="px-4 py-2">{row.month}</td>
                    <td className="px-4 py-2">{row.year}</td>
                    <td className="px-4 py-2">{row.all}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-center p-4">
            <button className="bg-gray-100 hover:bg-gray-200 text-gray-700 p-2 rounded-md">
              <RefreshCw size={18} />
            </button>
          </div>
        </div>

        {/* Incomplete Orders */}
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
          <div className="flex justify-between items-center border-b border-gray-200 p-4">
            <div className="flex items-center gap-2">
              <Hourglass className="text-gray-600" size={20} />
              <h2 className="text-lg font-semibold text-gray-700">
                Incomplete orders
              </h2>
            </div>
            <button className="text-gray-500 hover:text-gray-700">
              <RefreshCw size={18} />
            </button>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-700 border-t border-gray-100">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-2 font-semibold">Item</th>
                  <th className="px-4 py-2 font-semibold">Total</th>
                  <th className="px-4 py-2 font-semibold">Count</th>
                </tr>
              </thead>
              <tbody>
                {incompleteOrders.map((row, i) => (
                  <tr
                    key={i}
                    className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}
                  >
                    <td className="px-4 py-2">{row.item}</td>
                    <td className="px-4 py-2">{row.total}</td>
                    <td className="px-4 py-2">
                      <button className="flex items-center gap-1 bg-gray-100 hover:bg-gray-200 px-3 py-1 rounded-md text-sm text-gray-700">
                        <Eye size={16} /> {row.count} - view all
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-center p-4">
            <button className="bg-gray-100 hover:bg-gray-200 text-gray-700 p-2 rounded-md">
              <RefreshCw size={18} />
            </button>
          </div>
        </div>
      </div>
       <Dashboard4 />
    </div>
  );
}
